<template>
    <div class="video-card" v-if="showVideoCard">
      <div class="video-card-title flex-center">
        <div class="title">视频&集锦</div>
        <div class="icon flex-center" v-if="liveStatus && liveStatus.status === 2" @click="enterLiveRoom">
          <img src="https://images.snsports.cn/Flnr-yFVRRHD82-YrA5xY8IQLc_1" />
          回看录像
          <van-icon name="arrow" size="15" style="font-weight: 800;margin-left: 4px;" />
        </div>
      </div>
      <div class="live-card flex-center" v-if="liveStatus && liveStatus.status !== 2">
        <div class="poster" @click.stop="enterLiveRoom">
          <div class="img home">
            <img v-if="game.homeIcon" :src="game.homeIcon" />
            <div v-else>{{ homeInitial }}</div>
          </div>
          <div class="img away">
            <img v-if="game.awayIcon" :src="game.awayIcon" />
            <div v-else>{{ awayInitial }}</div>
          </div>
        </div>
        <div class="info">
          <div class="vs" v-if="game.type === 'game'">{{ game.homeName }} VS {{ game.awayName }}</div>
          <div class="vs" v-else></div>
          <div v-if="liveStatus && liveStatus.status === 1" class="live-info">
            <div class="live-info-time">
              <img src="https://images.snsports.cn/FvPGHJ_EFUhXU5Y43qoVHgOM9ao1" /> 
              <span style="color:#D54F3F;">直播中</span>
              <span style="color:#8E9196;margin-left: 7px;" v-if="game.pvCount">{{game.pvCount}}人</span>
            </div>
            <div class="live-info-card flex-center">
              <div class="share-btn btn" role="button" @click.stop="shareLiveRoom">分享直播间</div>
              <div class="enter-btn btn" role="button" @click.stop="enterLiveRoom">进入直播间</div>
            </div>
          </div>
          <div class="time" v-else>
            <img src="https://images.snsports.cn/FvPGHJ_EFUhXU5Y43qoVHgOM9ao1" alt="">
            直播还有 {{ daysUntilBegin }}
          </div>
        </div>
      </div>
      <div class="playback flex-center" v-else-if="lives.length > 0">
        <div class="video-item" v-for="item in lives" :key="item.videoId" @click="goToVideo(item)">
          <img :src="item.poster" />
          <div class="title">{{ item.title }}</div>
        </div>
      </div>
    </div>
</template>

<script>
import Moment from 'moment'
import wx from 'weixin-js-sdk'
import { Toast } from 'vant'
import { AppType } from '@/constants/appType'
import { QNImageUtil, isWeChatMiniApp, buildWebviewShareFullUrl } from '@/utils'

export default {
  props: {
    game: {
      type: Object,
      default: () => {}
    },
    match: {
      type: Object,
      default: () => {}
    },
    liveStatus: {
      type: Object,
      default: () => null
    },
    lives: {
      type: Array,
      default: () => []
    },
    gameId: {
      type: String,
      default: ''
    }
  },
  computed: {
    /** status === -1 表示本场无直播，整块「视频」区域不展示 */
    showVideoCard() {
      const ls = this.liveStatus
      if (!ls || typeof ls !== 'object') return false
      if (Number(ls.status) === -1) return false
      return true
    },
    homeInitial() {
      const s = String((this.game && this.game.homeName) || '').trim()
      return s ? Array.from(s)[0] : '—'
    },
    awayInitial() {
      const s = String((this.game && this.game.awayName) || '').trim()
      return s ? Array.from(s)[0] : '—'
    },
    /** `game.beginDate` 距今日 0 点还差几个自然日；无法解析为 null；已开赛日当天及之前为 0 */
    daysUntilBegin() {
      const m = Moment(this.game && this.game.beginDate)
      if (!m.isValid()) return null
      const n = m.clone().startOf('day').diff(Moment().startOf('day'), 'days')
      const day = n < 0 ? '0天' : n + '天'
      return day + ' ' + m.format('HH:mm:ss') + ' 开始'
    },
  },
  methods: {
    /** 分享当前页完整 H5 链接（与赛程/活动页、直播页逻辑一致） */
    buildShareParams() {
      const link = buildWebviewShareFullUrl(this.$route) || (typeof window !== 'undefined' ? window.location.href : '')
      const h = String((this.game && this.game.homeName) || '').trim()
      const a = String((this.game && this.game.awayName) || '').trim()
      const title = (h && a) ? `${h} VS ${a}` : (String((this.game && this.game.name) || '').trim() || '精彩赛事')
      const m = this.match || {}
      const matchLine = [m.name, m.groupName].filter(Boolean).join('/') || ''
      const rd = String((this.game && this.game.roundDescription) || '').trim()
      const abstract = [matchLine, rd].filter(Boolean).join('/') || '精彩赛事，欢迎观看'
      let image = ''
      if (m.icon) image = QNImageUtil.imageView(m.icon, 300, 300)
      else if (this.game && this.game.homeIcon) image = QNImageUtil.imageView(this.game.homeIcon, 300, 300)
      return { title, abstract, link, image }
    },
    copyToClipboard(text) {
      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        return navigator.clipboard.writeText(text)
      }
      return new Promise((resolve, reject) => {
        const ta = document.createElement('textarea')
        ta.value = text
        ta.style.position = 'fixed'
        ta.style.left = '-9999px'
        document.body.appendChild(ta)
        ta.select()
        try {
          document.execCommand('copy') ? resolve() : reject(new Error('copy failed'))
        } catch (e) {
          reject(e)
        } finally {
          document.body.removeChild(ta)
        }
      })
    },
    /**
     * 小程序 web-view / 微信 H5 / App：对齐 live-page `handleShare` 分流（当前页链接用 hash 拼接，避免 webview 分享错页）
     */
    shareLiveRoom() {
      const shareParams = this.buildShareParams()
      isWeChatMiniApp().then((isMini) => {
        if (isMini) {
          if (wx && wx.miniProgram && typeof wx.miniProgram.postMessage === 'function') {
            wx.miniProgram.postMessage({
              data: {
                type: 'setShareData',
                shareData: {
                  title: shareParams.title,
                  desc: shareParams.abstract,
                  imageUrl: shareParams.image,
                  path: '/pages/webview/index?redirect=' + encodeURIComponent(shareParams.link)
                }
              }
            })
          }
          Toast('请点击右上角···进行分享')
        } else if (AppType.isInWeChat() || AppType.isInApp()) {
          this.wxShare(shareParams)
          if (AppType.isInWeChat() && !AppType.isInApp()) {
            Toast('请点击右上角···将页面分享给好友')
          }
        } else {
          this.copyToClipboard(shareParams.link).then(() => Toast('链接已复制，快去分享吧')).catch(() => Toast('链接已复制，快去分享吧'))
        }
      })
    },
    enterLiveRoom() {
      this.$router.push({ path: `/live-page/${this.gameId}` })
    },
    goToVideo(item) {
      this.$router.push({ path: `/live-page/${this.gameId}`, query: { videoId: item.videoId } })
    }
  }
};
</script>

<style scoped lang="scss">
.video-card {
  padding: 12px 16px;
  .video-card-title {
    .title {
      font-size: 15px;
      font-weight: bold;
      color: #3D3D3D;
    }
    .icon{
      font-size: 14px;
      color: #C45656;
      img{
        width: 16px;
        height: 15px;
        margin-right: 6px;
      }
    }
  }
  .live-card{
    margin-top: 12px;
    > * + * {
      margin-left: 12px;
    }
    .poster{
      width: 128px;
      height: 72px;
      border-radius: 6px;
      background-image: url('https://images.snsports.cn/FqulelZhbnhXyPmxJbWGSiW2euEZ');
      background-size: 100% 100%;
      position: relative;
      .img{
        position: absolute;
        width: 24px;
        height: 24px;
        top: 24px;
        text-align: center;
        font-weight: bold;
        line-height: 24px;
        img{
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
      .home{
        left: 12px;
      }
      .away{
        right: 12px;
      }
    }
    .info{
      flex: 1;
      color: #3D3D3D;
      height: 72px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .vs{
        font-size: 14px;
      }
      .time{
        font-size: 13px;
        display: flex;
        align-items: center;
        img{
          width: 14px;
          height: 13px;
          margin-right: 6px;
        }
      }
      .live-info{
        .live-info-time{
          display: flex;
          align-items: center;
          font-size: 13px;
          font-weight: 300;
          img{
            width: 14px;
            height: 13px;
            margin-right: 3px;
          }
        }
        .live-info-card{
          margin-top: 6px;
          justify-content: start;
          > * + * {
            margin-left: 12px;
          }
          .btn{
            padding: 6px 4px;
            font-size: 12px;
            font-weight: 500;
            color: #fff;
            border-radius: 4px;
          }
          .share-btn{
            background: #D54F3F;
          }
          .enter-btn{
            background: #3FD57B;
          }
        }
      }
    }
  }
  .playback{
    justify-content: start !important;
    overflow-x: scroll;
    overflow-y: hidden;
    margin-top: 12px;
    .video-item{
      &:not(:last-child) {
        margin-right: 16px;
      }
      font-size: 0;
      width: 128px;
      min-width: 128px;
      height: 72px;
      position: relative;
      img{
        width: 100%;
        height: 100%;
      }
      .title{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 16px;
        line-height: 16px;
        background: rgba(0, 0, 0, 0.6);
        color: #FFFFFF;
        font-size: 12px;
        padding-left: 5px;
        box-sizing: border-box;
      }
    }
  }
}
</style>
